import { Pipe, PipeTransform } from '@angular/core';
import { countriesTranslations } from '@content/contact-us/connect-with-our-team/countries-dropdown/countries-translate';

@Pipe({
    name: 'countriesTranslate',
    standalone: true,
    pure: false,
})
export class CountriesTranslatePipe implements PipeTransform {
    public transform(value: string): string {
        if (!value) {
            return '';
        }
        return countriesTranslations[value] ?? '';
    }
}
